<template>
  <v-container fluid class="pt-0">
    <v-layout wrap>
      <v-flex xs12>
        <h2 class="headline mt-0">{{ $t('ChatGPT Conversation') }}</h2>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :loading="isLoading"
          :headers="tableDefaultConversationHeaders"
          :items="tableDashboardRows"
          hide-actions
          :no-data-text="$t('No Data')"
        >
          <template v-slot:items="props">
            <td>
              {{ props.item.question }}
            </td>
            <td>
              {{ props.item.summarize_question }}
            </td>
            <td>
              {{ props.item.answer }}
            </td>
          </template>
        </v-data-table>
        <v-layout>
          <v-pagination
            class="mt-2 ml-auto"
            v-model="pageDashboardNumber"
            :total-visible="6"
            :length="pageDashboardLength"
            @input="handleChangeDashboardPage"
          ></v-pagination>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import gptApi from '@/api/gpt'
export default {
  props: {
    selectedDate: {
      type: [Object],
      default: () => {}
    },
    channelFilter: {
      type: [String],
      default: 'all'
    }
  },
  data() {
    return {
      isLoading: false,
      tableDefaultConversationHeaders: [
        { text: this.$t('Question Name'), value: 'question', sortable: false },
        { text: this.$t('Summarize Question'), value: 'summarize_question', sortable: false },
        { text: this.$t('Chatbot answers'), value: 'answer', sortable: false }
      ],
      tableDashboardRows: [],
      pageDashboardTmp: 1,
      pageDashboardNumber: 1,
      totalDashboard: 0,
      limit: 10,
      offset: 0
    }
  },
  watch: {
    selectedDate: {
      handler() {
        this.handleGetData()
      },
      deep: true
    },
    channelFilter() {
      this.handleGetData()
    },
    isLoading(value) {
      this.$emit('loading', value)
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageDashboardLength() {
      if (this.totalDashboard) {
        let total = parseFloat(this.totalDashboard)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.handleResetState()
  },
  methods: {
    handleChangeDashboardPage(val) {
      if (this.pageDashboardTmp !== val) {
        this.pageDashboardTmp = val
        this.offset = this.pageDashboardNumber * this.limit - this.limit
        if (this.pageDashboardNumber != 1) {
          this.offset + 1
        }
        this.handleGetData()
      }
    },
    async handleGetData() {
      try {
        this.isLoading = true
        const response = await gptApi.getChatGPTConversation({
          pageId: this.selectedBot.pageid,
          params: {
            limit: this.limit,
            offset: this.offset,
            date_from: this.selectedDate.start,
            date_to: this.selectedDate.end,
            channel: this.channelFilter
          }
        })
        const { status, data } = response
        if ([200].includes(status)) {
          this.totalDashboard = data.total
          this.tableDashboardRows = data.data.map(item => {
            return {
              question: item.question,
              summarize_question: item.summarize_question,
              answer: item.answer_result
            }
          })
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    handleResetState() {
      this.isLoading = true
      this.tableDashboardRows = []
      this.pageDashboardTmp = 1
      this.pageDashboardNumber = 1
      this.totalDashboard = 0
      this.handleGetData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/chatgpt/GptConversation.vue